<script>
  /**
   * Icon Component - Dynamic SVG icon renderer using Lucide icons
   * @component
   */
  import * as LucideIcons from "lucide-svelte";

  let {
    name = "",
    size = 20,
    class: className = "",
    color = "currentColor",
    ...rest
  } = $props();

  // Get the icon component dynamically
  const IconComponent = $derived(name ? LucideIcons[name] : null);
</script>

{#if IconComponent}
  <IconComponent {size} class={className} {color} {...rest} />
{/if}
